// extracted by mini-css-extract-plugin
export var activeDot = "_6a-c";
export var buttonContainer = "_6a-9";
export var channelButton = "_6a-a";
export var content = "_6a-0";
export var contentFull = "_6a-2";
export var contentThird = "_6a-1";
export var contentWrapper = "_6a-7";
export var description = "_6a-5";
export var heightShort = "_6a-e";
export var image = "_6a-3";
export var imageContainer = "_6a-4";
export var selectButton = "_6a-d";
export var spinnerContainer = "_6a-b";
export var titleContent = "_6a-8";
export var titleWrapper = "_6a-6";